"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rateLimit = void 0;
const rate_limitify_1 = require("./rate-limitify");
function rateLimit(config) {
    return (target, propertyName, descriptor) => {
        if (descriptor.value) {
            descriptor.value = (0, rate_limitify_1.rateLimitify)(descriptor.value, config);
            return descriptor;
        }
        throw new Error('@rateLimit is applicable only on a method.');
    };
}
exports.rateLimit = rateLimit;
